import { wsService } from "./wsService";
import sections from "@/constants/sections";

const section = sections.SECTION_FORMULAS;

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_put_request(section + "/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function list_types() { 
  return wsService.make_post_request(section + "/list-types");
}

function list_types_formula_items() { 
  return wsService.make_post_request(section + "/list-types-formula-items");
}


function filter_semi_elaboradas() {
  return wsService.make_post_request(section + "/list-semi-elaboradas");
}

function print(formula_id) {
  return wsService.make_post_request(
    section + "/print",
    { id: formula_id },
    {
      responseType: "arraybuffer",
      headers: {
        Accept: "application/pdf",
      },
    }
  );
}

export const formulaService = {
  section,
  filter,
  remove,
  create,
  update,
  list_types,
  list_types_formula_items,
  filter_semi_elaboradas,
  print,
};
